export const wellbeingCategories = [
  "connection",
  "movement",
  "recovery",
  "gratitude",
  "meaning",
  "presence",
  "other",
] as const;

export type WellbeingCategory = (typeof wellbeingCategories)[number];

export const categoryLabels: Record<WellbeingCategory, string> = {
  connection: "Närhet",
  movement: "Rörelse",
  recovery: "Återhämtning",
  gratitude: "Tacksamhet",
  meaning: "Mening",
  presence: "Närvaro",
  other: "Övrigt",
};

/** Category colors. Text must never rely on color alone. */
export const categoryTokens = {
  connection: {
    foreground: "hsl(340 45% 43%)",
    background: "hsl(340 52% 93%)",
    foregroundDark: "hsl(340 48% 78%)",
    backgroundDark: "hsl(340 22% 22%)",
  },
  movement: {
    foreground: "hsl(150 32% 35%)",
    background: "hsl(150 35% 91%)",
    foregroundDark: "hsl(150 34% 70%)",
    backgroundDark: "hsl(150 18% 20%)",
  },
  recovery: {
    foreground: "hsl(215 38% 43%)",
    background: "hsl(215 47% 92%)",
    foregroundDark: "hsl(215 45% 76%)",
    backgroundDark: "hsl(215 20% 22%)",
  },
  gratitude: {
    foreground: "hsl(31 65% 39%)",
    background: "hsl(31 72% 91%)",
    foregroundDark: "hsl(31 70% 72%)",
    backgroundDark: "hsl(31 24% 22%)",
  },
  meaning: {
    foreground: "hsl(264 34% 43%)",
    background: "hsl(264 42% 92%)",
    foregroundDark: "hsl(264 40% 78%)",
    backgroundDark: "hsl(264 20% 24%)",
  },
  presence: {
    foreground: "hsl(185 35% 34%)",
    background: "hsl(185 37% 91%)",
    foregroundDark: "hsl(185 36% 70%)",
    backgroundDark: "hsl(185 18% 20%)",
  },
  other: {
    foreground: "hsl(230 12% 40%)",
    background: "hsl(40 18% 92%)",
    foregroundDark: "hsl(230 14% 78%)",
    backgroundDark: "hsl(230 10% 22%)",
  },
} as const;
